import { app as api } from '@ekuaibao/whispered';
export var isExternalCharge = function () {
    return api.getState('@common').powers.ExternalAuth;
};
